module.exports = __webpack_public_path__ + "img/nav-03.7c307767.svg";